// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
var define;
var is_node = typeof module=='object' && module.exports;
if (is_node)
    define = require('../../../../util/require_node.js').define(module, '..');
else
    define = self.define;
define([], ()=>{
const E = {};
E.intro = [['div',
    [['h1',
        [`Shell Coding Convention`],
        {className: `title`},
    ],
    ['p',
        [['b',
            [`Improvements? Suggestions?`],
        ],
        ` email `,
        ['a',
            [`dna@hola.org`],
            {href: `mailto:dna@hola.org`},
        ],
        ` `],
    ],
    ['p',
        [` Coding conventions used by other companies: `,
        ['a',
            [`google`],
            {href: `https://google.github.io/styleguide/shell.xml`},
        ],
        ` `],
    ]],
    {className: `head`},
]];
E.data = [
    {
        id: 'dict',
        title: '',
        tag: 'h2',
        html: [],
        short: 'Shell',
    },
    {
        id: 'general',
        title: `General`,
        tag: 'h3',
        short: `General`,
        html: [['p',
            [` In general, most of C coding convention apply to Bash coding
                convention, for example: `],
        ],
        ['ul',
            [['li',
                [`- Indentation is always one shift-width(4):`],
            ],
            ['li',
                [`- case has the same indentatio level and switch`],
            ],
            ['li',
                [`- ...`],
            ]],
        ]],
    },
    {
        id: 'function_params',
        title: `Function parameters`,
        tag: 'h3',
        short: `Function parameters`,
        html: [['p',
            [`Function parameters should define local their names, not use
                $1, $2...`],
        ],
        ['div',
            [['pre',
                [`foo()
{
    cp $1 $2
}
`],
                {className: `cm-s-default code bad  has-popover`,
                    cat: `bad`,
                    'data-content': `BAD`,
                    'data-original-title': ``,
                    title: ``},
            ],
            ['pre',
                [`foo()
{
    local src=$1 dst=$2
    cp $src $dst
}
`],
                {className: `cm-s-default code good  has-popover`,
                    cat: `good`,
                    'data-content': `GOOD`,
                    'data-original-title': ``,
                    title: ``},
            ]],
            {className: `bad_good_bind`},
        ]],
    },
    {
        id: 'return_string',
        title: `returning a string value:
  RS="the value"`,
        tag: 'h3',
        short: `returning a string`,
        html: [['div',
            [['pre',
                [`install_dir()
{
    echo "/usr/local/bin"
}

install app.sh \`install_dir\`
`],
                {className: `cm-s-default code bad  has-popover`,
                    cat: `bad`,
                    'data-content': `BAD`,
                    'data-original-title': ``,
                    title: ``},
            ],
            ['pre',
                [`install_dir()
{
    RS="/usr/local/bin"
}

install_dir
install app.sh $RS
`],
                {className: `cm-s-default code good  has-popover`,
                    cat: `good`,
                    'data-content': `GOOD`,
                    'data-original-title': ``,
                    title: ``},
            ]],
            {className: `bad_good_bind`},
        ]],
    },
    {
        id: 'return_array',
        title: `returning an array value:
  RA=(the values...)`,
        tag: 'h3',
        short: `returning an array`,
        html: [['pre',
            [`install_paths()
{
    RA=(/usr/local/bin /usr/local /etc)
}

install_paths
for p in "\${RA[@]}"; do try_install "$p"; done
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'return_multi',
        title: `
  returning multiple string/array values`,
        tag: 'h3',
        short: `returning multiple string/array values`,
        html: [['p',
            [`returning multiple string/array values use `,
            ['code',
                [`RS_{name}`],
            ],
            ` or `,
            ['code',
                [`RA_{name}:`],
            ]],
        ],
        ['pre',
            [`install_app()
{
    RS_dir=/usr/local/bin
    RA_paths=(/usr/local/bin /usr/local /etc)
}

install_app
try_install "$RS_dir" "\${RA_paths[@]}"
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'argv_handling',
        title: `argv handling and usage()`,
        tag: 'h3',
        short: `argv handling`,
        html: [['p',
            [`argv handling and usage(): use shift to process, and always
                have usage() function:`],
        ],
        ['pre',
            [`usage()
{
    echo "usage: ..."
    exit 1
}
while [ "\${1:0:1}" = - ]; do
    case "$1" in
    --option)
        ... set option ...
        ;;
    --option-with-arg)
        shift
        if [ -z "$1" ]; then
            usage
        fi
        ... use *argv to set option ...
        ;;
    *)
        usage
        ;;
    esac
    shift
done
... handle arguments left in argv ...
if [ -n "$1" ]; then
    usage
fi
... start working ...
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'int_operations',
        title: `Where
  integer operations are relevant`,
        tag: 'h3',
        short: `Where integer operations are relevant`,
        html: [['p',
            [`Where integer operations are relevant, use ((C_EXPRESSION))
                instead of [SHELL_EXPRESSION]:`],
        ],
        ['div',
            [['pre',
                [`if [ "$prep_inc" == 1 ]; then
    enable_prep
fi
`],
                {className: `cm-s-default code bad  has-popover`,
                    cat: `bad`,
                    'data-content': `BAD`,
                    'data-original-title': ``,
                    title: ``},
            ],
            ['pre',
                [`if ((prep_inc)); then
    enable_prep
fi
`],
                {className: `cm-s-default code good  has-popover`,
                    cat: `good`,
                    'data-content': `GOOD`,
                    'data-original-title': ``,
                    title: ``},
            ]],
            {className: `bad_good_bind`},
        ]],
    },
    {
        id: 'shell_expressions',
        title: `SHELL EXPRESSIONS`,
        tag: 'h3',
        short: `SHELL EXPRESSIONS`,
        html: [['p',
            [`In SHELL EXPRESSIONS use `,
            ['code',
                [`[[ ]]`],
            ],
            ` instead of `,
            ['code',
                [`[ ]`],
            ],
            ` when AND/OR is needed:`],
        ],
        ['div',
            [['pre',
                [`if [ -z "$install_dir" -o ! -d "$install_dir" ]; do
    install_the_dir
fi
`],
                {className: `cm-s-default code bad  has-popover`,
                    cat: `bad`,
                    'data-content': `BAD`,
                    'data-original-title': ``,
                    title: ``},
            ],
            ['pre',
                [`if [[ -z "$install_dir" || ! -d "$install_dir" ]]; do
    install_the_dir
fi
`],
                {className: `cm-s-default code good  has-popover`,
                    cat: `good`,
                    'data-content': `GOOD`,
                    'data-original-title': ``,
                    title: ``},
            ]],
            {className: `bad_good_bind`},
        ]],
    },
    {
        id: 'script_included',
        title: `When the script is included in
  other scripts`,
        tag: 'h3',
        short: `Script included`,
        html: [['p',
            [`When the script is included in other scripts, use the following
                method to avoid multiple includes:`],
        ],
        ['pre',
            [`  if ((__FULL_PATH_FROM_PGK_FILENAME__)); then
      return 0
  fi
  __FULL_PATH_FROM_PGK_FILENAME__=1

example:
  if ((__SYSTEM_SCRIPTS_JTOOLS_FUNCTIONS_SH__)); then
      return 0
  fi
  __SYSTEM_SCRIPTS_JTOOLS_FUNCTIONS_SH__=1
`],
            {className: `cm-s-default code good  has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ]],
    },
    {
        id: 'quotation',
        title: `Quotation:`,
        tag: 'h3',
        html: [['p',
            [` the sign `,
            ['code',
                [`$@`],
            ],
            ` is a special sign for all the parameters passed to the
                function.`,
            ['br'],
            ` when quoting it `,
            ['code',
                [`"$@"`],
            ],
            ` bash will quote each parameter seperatly. `,
            ['br'],
            ` if you want to use all the parameters, you should use an
                array:`,
            ['br'],
            ['code',
                [`cmd=("$@")`],
            ],
            ['br'],
            ['code',
                [`cmd=("\${cmd[@]}" "some other text")`],
            ],
            ['br'],
            ['code',
                [`"\${cmd[@]}"`],
            ],
            ['br'],
            ` The above three lines, save the parameters into an array, adds
                to it another`,
            ['br'],
            ` value and then us it as a bash command.`,
            ['br'],
            ['br'],
            ` Quotation should always take under consideration when passing
                vars and arrays to other functions or when excecuted as a
                command.`,
            ['br']],
        ]],
    },
];
return E;
});
